import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LogoMark } from "@/components/site/Logo";
import { AccountButton, CartButton } from "@/components/site/HeaderActions";

export const ProductHeader = () => (
  <header className="sticky top-0 z-40 flex h-16 items-center justify-between border-b border-line bg-ink/85 px-5 backdrop-blur-xl sm:px-8 lg:px-12" data-testid="product-header">
    <div className="flex items-center gap-5">
      <Link to="/" className="flex items-center gap-2.5" data-testid="product-home-link">
        <LogoMark className="h-8 w-8" />
        <span className="hidden font-display text-sm font-black tracking-[0.2em] sm:inline">SFUMO</span>
      </Link>
      <Link to="/#sfushop" data-testid="product-back-shop-link" className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-bone/80 transition-colors hover:text-acid">
        <ArrowLeft className="h-3.5 w-3.5" /> Shop
      </Link>
    </div>
    <div className="flex items-center gap-2">
      <AccountButton />
      <CartButton />
    </div>
  </header>
);
